import CheckOutlined from '@ant-design/icons/CheckOutlined'
import CloseOutlined from '@ant-design/icons/CloseOutlined'
import DeleteOutlined from '@ant-design/icons/DeleteOutlined'
import FileTextOutlined from '@ant-design/icons/FileTextOutlined'
import PlusOutlined from '@ant-design/icons/PlusOutlined'
import UploadOutlined from '@ant-design/icons/UploadOutlined'
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Row,
  Select,
  Table,
  Upload,
} from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import PropTypes from 'prop-types'
import React, {
  memo,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react'
import FileItem from '../../../../components/Common/FileItemComponent/FileItem'
import RichEditor from '../../../../components/RichEditor/RichEditor'
import SelectPeoplePopup from '../../../../components/SelectPeoplePopup'
import { ASSIGNEE_TYPE_CONFIG } from '../../../../components/SubmissionForm/ProposalStepApprove'
import ProposalStepApproveUpdate from '../../../../components/SubmissionForm/ProposalStepApproveUpdate'
import {
  ASSIGNEE_TYPE,
  DATE_FORMAT_LIST,
  ISO_DATE_FORMAT,
  MODES,
  SHIFTS,
} from '../../../../constants'
import utils from '../../../../utils'
import ApprovalList from '../../../Administrative/LeaveForm/ApproverListModal/Modal'
import {
  FormActionFooter,
  OriginFilesList,
} from '../../../MissionEditPage/MissionEditPageStyled'
import validator from './../../../../validator'

const { RangePicker } = DatePicker
const { Option } = Select

const ProposalDetailUpdate = props => {
  const {
    proposalStore,
    selectPeopleStore,
    fileStore,
    proposalType,
    proposalTypeStore,
    name,
    approvalTemplateStore,
    onUpdateApprovalLevels,
  } = props

  const {
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    selectUserData,
    selectDepartmentData,
    selectGroupData,
  } = selectPeopleStore
  const { otherDetail } = proposalStore

  const [form] = Form.useForm()
  const CONTENT_REF = useRef()
  const isMountedRef = useRef(true)

  const [fileList, setFileList] = useState([])
  const [editorContent, setEditorContent] = useState()
  const [followerList, setFollowerList] = useState([])
  const [originFiles, setOriginFiles] = useState([])
  const [isUpdating, setIsUpdating] = useState(false)
  const [arrSubmissionMenu, setArrSubmissionMenu] = useState([])
  const [reasonForLeaving, setReasonForLeaving] = useState('')
  const [selectedDates, setSelectedDates] = useState([])
  const [proposalTimeList, setProposalTimeList] = useState([])
  const [approvalLevels, setApprovalLevels] = useState([])
  const [
    selectedApproveTemplateCode,
    setSelectedApproveTemplateCode,
  ] = useState('')
  const [approvalTemplateList, setApprovalTemplateList] = useState([])
  const [deletedApprovalLevels, setDeletedApprovalLevels] = useState([])
  const [newApprovalLevels, setNewApprovalLevels] = useState([])
  const [isInitialized, setIsInitialized] = useState(false)

  const normalizeLevels = levels => {
    const activeLevels = levels
      .filter(level => !level.isDeleted)
      .sort((a, b) => a.level - b.level)
      .map((level, index) => ({
        ...level,
        level: index,
      }))

    // Xử lý status theo quy tắc nghiệp vụ
    const processedLevels = activeLevels.map((level, index) => {
      if (index === 0) {
        return {
          ...level,
          status: 'CREATED',
        }
      }

      // Nếu level này đã được approve thì giữ nguyên status
      if (level.status === 'APPROVED') {
        return level
      }

      // Tìm cấp approve cuối cùng
      let lastApprovedIndex = -1
      for (let i = index - 1; i >= 0; i--) {
        if (activeLevels[i].status === 'APPROVED') {
          lastApprovedIndex = i
          break
        }
      }

      // Nếu cấp hiện tại là cấp ngay sau cấp approved cuối cùng
      if (lastApprovedIndex !== -1 && index === lastApprovedIndex + 1) {
        return {
          ...level,
          status: 'PENDING',
        }
      }

      // Nếu không có cấp nào được approve và đây là cấp đầu tiên (sau CREATED)
      if (lastApprovedIndex === -1 && index === 1) {
        return {
          ...level,
          status: 'PENDING',
        }
      }

      // Các cấp còn lại sẽ là WAITING
      return {
        ...level,
        status: 'WAITING',
      }
    })

    return processedLevels
  }

  const defaultDateRange = useMemo(() => {
    if (!otherDetail?.from_date || otherDetail.from_date === '') {
      return []
    }
    return [
      moment(otherDetail.from_date, ISO_DATE_FORMAT),
      moment(otherDetail.to_date, ISO_DATE_FORMAT),
    ]
  }, [otherDetail?.from_date, otherDetail.to_date])

  useEffect(() => {
    return () => {
      isMountedRef.current = false
    }
  }, [])

  useEffect(() => {
    if (!otherDetail?.id || isInitialized || !isMountedRef.current) return

    const hasUserModifications =
      approvalLevels.some(level => !level.isExisting) ||
      deletedApprovalLevels.length > 0 ||
      newApprovalLevels.length > 0

    if (hasUserModifications) return

    const initializeData = async () => {
      try {
        await selectPeopleStore.clearSelectUserData()
        await selectPeopleStore.clearSelectDepartmentData()
        await selectPeopleStore.clearSelectGroupData()

        form.setFieldsValue({
          title: otherDetail.title,
          proposal_type: name,
        })

        setEditorContent(otherDetail.reason || '')
        setProposalTimeList(otherDetail.proposalTimeList || [])
        setSelectedDates(defaultDateRange)
        setReasonForLeaving(otherDetail.reason_for_leaving || '')

        const followerList = []
        if (otherDetail.followers && Array.isArray(otherDetail.followers)) {
          otherDetail.followers.forEach(follower => {
            if (follower?.user_name) {
              followerList.push({
                assignee_type: ASSIGNEE_TYPE.USER,
                full_name:
                  follower.name_lowercase?.toUpperCase() || follower.user_name,
                id: follower.user_name,
                image_id: follower.image_id,
                permission: ASSIGNEE_TYPE.FOLLOWER,
              })
            }
          })

          if (followerList.length > 0) {
            selectPeopleStore.setSelectUserData({
              ...selectUserData,
              [ASSIGNEE_TYPE.FOLLOWER]: followerList,
            })
          }
        }

        setOriginFiles(otherDetail.attachments || [])

        const initialApprovalLevels = (otherDetail.approval_levels || [])
          .map(level => ({
            ...level,
            status: level.status,
            allow_edit: level.allow_edit,
            code: level.code,
            isDeleted: false,
            level: level.level,
            name: level.name,
            username: level.username,
            user: level.username ? { username: level.username } : null,
            isExisting: true,
          }))
          .sort((a, b) => a.level - b.level)

        setApprovalLevels(initialApprovalLevels)
        setDeletedApprovalLevels([])
        setNewApprovalLevels([])

        // FIX: Chỉ set store khi khởi tạo lần đầu
        proposalStore.setDefaultApprovalConfigUpdate({
          approvalLevels: initialApprovalLevels,
        })

        if (otherDetail.approval_template_code) {
          setSelectedApproveTemplateCode(otherDetail.approval_template_code)
        }

        setIsInitialized(true)
      } catch (error) {
        console.error('Error initializing data:', error)
        if (isMountedRef.current) {
          message.error('Có lỗi khi khởi tạo dữ liệu')
        }
      }
    }

    initializeData()
  }, [
    otherDetail?.id,
    isInitialized,
    approvalLevels.length,
    deletedApprovalLevels.length,
    newApprovalLevels.length,
  ])

  useEffect(() => {
    if (approvalTemplateStore.approvalTemplateList && isMountedRef.current) {
      const templates = approvalTemplateStore.approvalTemplateList.filter(
        item => item.templateType === 'proposal' && !item.isDeleted
      )
      setApprovalTemplateList(templates)
    }
  }, [approvalTemplateStore.approvalTemplateList])

  const memoizedFollowerList = useMemo(() => {
    const followers = [
      ...(selectUserData[ASSIGNEE_TYPE.FOLLOWER] || []),
      ...(selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER] || []),
      ...(selectGroupData[ASSIGNEE_TYPE.FOLLOWER] || []),
    ]
    return followers
  }, [
    selectUserData[ASSIGNEE_TYPE.FOLLOWER],
    selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER],
    selectGroupData[ASSIGNEE_TYPE.FOLLOWER],
  ])

  useEffect(() => {
    if (JSON.stringify(memoizedFollowerList) !== JSON.stringify(followerList)) {
      setFollowerList(memoizedFollowerList)
    }
  }, [memoizedFollowerList])

  const handleChangeFile = useCallback(info => {
    const filteredFileList = info.fileList.filter(
      (elem, index, fileArray) =>
        fileArray.findIndex(file => file.name === elem.name) === index
    )
    setFileList(filteredFileList)
  }, [])

  const onFinish = useCallback(
    async values => {
      if (!isMountedRef.current) return

      if (!values.title?.trim()) {
        return message.warning('Hãy nhập tiêu đề!')
      }

      const activeApprovalLevels = approvalLevels.filter(
        level => !level.isDeleted
      )

      // FIX: Sử dụng approvalLevels state thay vì store data
      const hasEmptyApprovalLevel = activeApprovalLevels.some(
        item => !item?.username || item.username.trim() === ''
      )

      if (hasEmptyApprovalLevel) {
        message.warning('Hãy chọn đủ cấp duyệt!')
        return
      }

      const uploadFileList = fileList
        ? fileList.map(file => file.originFileObj)
        : []
      const batchUploadArr = []

      uploadFileList.forEach(file => {
        const formData = new FormData()
        formData.append('file', file)
        batchUploadArr.push(fileStore.uploadFile(formData))
      })

      let newAttachments = []
      let removeAttachments = []
      try {
        const response = await Promise.all(batchUploadArr)
        if (!isMountedRef.current) return

        const originFileList = (otherDetail.attachments || []).map(
          file => file.file_id
        )

        const afterFileList = [
          ...response.map(el => el.data.file_id),
          ...originFiles.map(file => file.file_id),
        ]

        afterFileList.forEach(file => {
          if (!originFileList.includes(file)) {
            newAttachments.push(file)
          }
        })

        originFileList.forEach(file => {
          if (!afterFileList.includes(file)) {
            removeAttachments.push(file)
          }
        })
      } catch (err) {
        if (isMountedRef.current) {
          message.error(err?.vi || 'Có lỗi khi tải lên tệp!')
        }
        return
      }

      const removeFollowers = otherDetail.followers.filter(follower => {
        if (!followerList.some(item => item.id === follower.user_name)) {
          return follower
        }
      })

      const newFollowers = followerList.filter(follower => {
        if (
          !otherDetail.followers.some(item => item.user_name === follower.id)
        ) {
          return follower
        }
      })

      let fromDate =
        values?.date_picker && values?.date_picker.length === 2
          ? moment(values.date_picker[0]).format(ISO_DATE_FORMAT)
          : defaultDateRange.length > 0
          ? moment(defaultDateRange[0]).format(ISO_DATE_FORMAT)
          : ''
      let toDate =
        values?.date_picker && values?.date_picker.length === 2
          ? moment(values.date_picker[1]).format(ISO_DATE_FORMAT)
          : defaultDateRange.length > 0
          ? moment(defaultDateRange[1]).format(ISO_DATE_FORMAT)
          : ''

      const updatedProposalTimeList = proposalTimeList.map(day => ({
        ...day,
        note:
          noteRefs.current[day.id] !== undefined
            ? noteRefs.current[day.id]
            : day.note,
      }))

      const proposal = {
        ...values,
        code: otherDetail.proposal_code,
        title: values.title.replace(/\s+/g, ' ').trim(),
        proposal_type: otherDetail.proposal_type,
        attachments: {
          remove_items: removeAttachments,
          new_items: newAttachments,
        },
        assignees: {
          remove_items: [],
          new_items: [],
        },
        reason_for_leaving: reasonForLeaving,
        from_date: fromDate,
        to_date: toDate,
        overtime: otherDetail.overtime,
        reason: CONTENT_REF.current.editor.getData(),
        proposalTimeList: updatedProposalTimeList,
        approval_levels: activeApprovalLevels,
      }

      const updateApprovalLevels = async () => {
        // Step 1: Delete existing levels if any
        if (deletedApprovalLevels.length > 0) {
          const codesToDelete = deletedApprovalLevels
            .filter(level => level.isExisting && level.code)
            .map(level => level.code)

          if (codesToDelete.length > 0) {
            await proposalStore.deleteProposalApprovalLevel(
              otherDetail.proposal_code,
              codesToDelete
            )
            await proposalStore.getOtherDetail(otherDetail.proposal_code)
          }
        }

        // Step 2: Detect changed assignees/comments
        const currentServerLevels = otherDetail.approval_levels || []
        const changedLevels = activeApprovalLevels
          .filter(level => {
            const serverLevel = currentServerLevels.find(
              sl => sl.code === level.code
            )
            return (
              serverLevel &&
              (serverLevel.username !== level.username ||
                serverLevel.comment !== level.comment) &&
              level.allow_edit &&
              !level.isDeleted
            )
          })
          .map(level => ({
            levelCode: level.code,
            username: level.username || null,
            comment: null,
          }))

        // Step 3: Update changed assignees/comments
        if (changedLevels.length > 0) {
          try {
            await proposalStore.updateMultipleApprovalLevelAssignees(
              otherDetail.proposal_code,
              changedLevels
            )
          } catch (error) {
            throw new Error(
              error?.response?.data?.vi || 'Có lỗi khi cập nhật người phê duyệt'
            )
          }
        }

        // Step 4: Create new levels
        const currentServerLevelCodes = currentServerLevels.map(
          level => level.code
        )
        const maxServerLevel =
          currentServerLevels.length > 0
            ? Math.max(...currentServerLevels.map(level => level.level))
            : -1

        const newLevelsToCreate = normalizeLevels(
          activeApprovalLevels.filter(
            level =>
              !currentServerLevelCodes.includes(level.code) &&
              !level.isDeleted &&
              level.username &&
              level.username.trim() !== ''
          )
        ).map((level, index) => ({
          level: maxServerLevel + 1 + index,
          name:
            maxServerLevel + 1 + index === 0
              ? 'Bộ phận đề nghị'
              : `Cấp duyệt ${maxServerLevel + 1 + index + 1}`,
          username: level.username,
          allow_edit: level.allow_edit !== false,
          status:
            maxServerLevel + 1 + index === 0
              ? 'CREATED'
              : maxServerLevel + 1 + index === 1
              ? 'PENDING'
              : 'WAITING',
          comment: level.comment || null,
        }))

        if (newLevelsToCreate.length > 0) {
          try {
            await proposalStore.createProposalApprovalLevels(
              otherDetail.proposal_code,
              newLevelsToCreate
            )
          } catch (error) {
            throw new Error(
              error?.response?.data?.vi || 'Có lỗi khi tạo cấp duyệt mới'
            )
          }
        }
      }

      try {
        if (!isMountedRef.current) return
        setIsUpdating(true)

        // Cập nhật approval levels
        // await updateApprovalLevels()

        // Cập nhật đề xuất
        await proposalStore.updateProposal(proposal)
        if (!isMountedRef.current) return

        // Refresh data cuối cùng
        await proposalStore.getOtherDetail(proposal.code)
        if (!isMountedRef.current) return

        message.success('Chỉnh sửa thành công!')
        props.onCancel()
      } catch (error) {
        if (isMountedRef.current) {
          message.error(error?.vi || 'Có lỗi xảy ra')
        }
      } finally {
        if (isMountedRef.current) {
          setIsUpdating(false)
        }
      }
    },
    [
      approvalLevels,
      deletedApprovalLevels,
      newApprovalLevels,
      fileList,
      followerList,
      defaultDateRange,
      otherDetail,
      proposalStore,
      proposalTimeList,
      reasonForLeaving,
      isMountedRef,
      fileStore,
      originFiles,
      CONTENT_REF,
      message,
      props.onCancel,
      setIsUpdating,
    ]
  )

  const handleShiftChange = useCallback((value, recordId) => {
    setProposalTimeList(prev =>
      prev.map(day => (day.id === recordId ? { ...day, shift: value } : day))
    )
  }, [])

  const handleModeChange = useCallback((value, recordId) => {
    let modeTypeValue = 0
    if (value === MODES.WOMEN.key) {
      modeTypeValue = 0.5
    } else if (value === MODES.CHILD_CARE.key) {
      modeTypeValue = 1
    }

    setProposalTimeList(prev =>
      prev.map(day =>
        day.id === recordId
          ? { ...day, mode: value, mode_type: modeTypeValue }
          : day
      )
    )
  }, [])

  const handleModeTypeChange = useCallback((value, recordId) => {
    setProposalTimeList(prev =>
      prev.map(day =>
        day.id === recordId ? { ...day, mode_type: value } : day
      )
    )
  }, [])

  const noteRefs = useRef({})

  const handleNoteChange = useCallback((value, recordId) => {
    noteRefs.current[recordId] = value

    setProposalTimeList(prev =>
      prev.map(day => (day.id === recordId ? { ...day, note: value } : day))
    )
  }, [])

  const handleDateChange = useCallback((value, dates) => {
    setSelectedDates(dates)
  }, [])

  const getRange = useCallback((startDate, endDate) => {
    let fromDate = moment(startDate, 'DD/MM/YYYY')
    let toDate = moment(endDate, 'DD/MM/YYYY')
    let diff = toDate.diff(fromDate, 'days')
    let range = []

    for (let i = 0; i <= diff; i++) {
      let currentDay = moment(startDate, 'DD/MM/YYYY').add(i, 'days')
      range.push(currentDay)
    }

    return range
  }, [])

  const generateWorkDays = useCallback(() => {
    if (!selectedDates || selectedDates.length < 2) {
      setProposalTimeList([])
      return
    }

    const workDays = []
    const dateRange = getRange(selectedDates[0], selectedDates[1])

    if (dateRange?.length > 0) {
      dateRange.forEach((date, index) => {
        const formattedDate = date
        const existingDay = otherDetail?.proposalTimeList?.find(
          day =>
            moment(day.date).format('DD/MM/YYYY') ===
            moment(formattedDate).format('DD/MM/YYYY')
        )

        if (existingDay) {
          workDays.push({
            ...existingDay,
            id: existingDay.id || `${index}_${Date.now()}`, // Đảm bảo có id
          })
        } else {
          if (proposalType === 'LEAVE_ABNORMAL') {
            workDays.push({
              id: `${index}_${Date.now()}`, // Đảm bảo id duy nhất
              date: formattedDate,
              shift: 'morning',
              mode: 'normal',
              mode_type: 0,
              note:
                noteRefs.current[`${index}_${Date.now()}`] ||
                existingDay?.note ||
                null,
            })
          } else {
            workDays.push({
              id: `${index}_${Date.now()}`, // Đảm bảo id duy nhất
              date: formattedDate,
              shift: 'allDay',
              mode: 'normal',
              note: null,
            })
          }
        }
      })
      setProposalTimeList(workDays)
    } else {
      setProposalTimeList([])
    }
  }, [
    selectedDates,
    getRange,
    otherDetail?.proposalTimeList,
    proposalType,
    noteRefs,
  ])

  // Only generate work days when selectedDates change and initialization is complete
  useEffect(() => {
    if (selectedDates?.length > 0 && isInitialized) {
      generateWorkDays()
    }
  }, [selectedDates, isInitialized, generateWorkDays])

  const handleAddApprovalLevel = useCallback(() => {
    const activeLevels = approvalLevels.filter(level => !level.isDeleted)

    if (activeLevels.length >= 8) {
      message.info('Đã vượt quá số cấp duyệt cho phép.')
      return
    }

    const allApprovedOrCreated = activeLevels.every(
      level => level.status === 'APPROVED' || level.status === 'CREATED'
    )

    const newLevel = {
      status: allApprovedOrCreated ? 'PENDING' : 'WAITING',
      allow_edit: true,
      isDeleted: false,
      level: activeLevels.length + 1,
      name: `Cấp duyệt ${activeLevels.length + 1}`,
      username: '',
      user: null,
      code: `APVLVL${Date.now()}${Math.random().toString(36).substr(2, 9)}`,
      isExisting: false,
    }

    const updatedLevels = [...approvalLevels, newLevel]
    const normalizedLevels = normalizeLevels(updatedLevels)

    setApprovalLevels(normalizedLevels)
    setNewApprovalLevels(prev => {
      const existingCodes = prev.map(l => l.code)
      return existingCodes.includes(newLevel.code) ? prev : [...prev, newLevel]
    })

    // Giữ nguyên selectUserData cũ và thêm assignee type mới
    const newAssigneeType =
      ASSIGNEE_TYPE_CONFIG[activeLevels.length] ||
      `DYNAMIC_LEVEL_${activeLevels.length}`
    selectPeopleStore.setSelectUserData({
      ...selectUserData,
      [newAssigneeType]: [],
    })

    proposalStore.setDefaultApprovalConfigUpdate({
      approvalLevels: normalizedLevels,
    })
  }, [
    approvalLevels,
    proposalStore,
    message,
    selectPeopleStore,
    selectUserData,
  ])

  // FIXED: Sửa lại function handleRemoveApprovalLevel để bảo toàn dữ liệu
  const handleRemoveApprovalLevel = useCallback(
    level => {
      if (approvalLevels.length <= 2) {
        message.warning('Phải có ít nhất 2 cấp duyệt!')
        return
      }

      selectPeopleStore.clearSelectedByType(ASSIGNEE_TYPE_CONFIG[level.level])

      const code = level.code
      const levelToRemove = approvalLevels.find(l => l.code === code)

      if (!levelToRemove) {
        return
      }

      let updatedLevels = [...approvalLevels]
      let updatedDeletedLevels = [...deletedApprovalLevels]
      let updatedNewLevels = [...newApprovalLevels]

      if (levelToRemove.isExisting) {
        // For existing levels, mark as deleted
        const isAlreadyDeleted = updatedDeletedLevels.some(
          deletedLevel => deletedLevel.code === code
        )
        if (!isAlreadyDeleted) {
          updatedDeletedLevels.push({ ...levelToRemove, isDeleted: true })
        }
        updatedLevels = updatedLevels.map(l =>
          l.code === code ? { ...l, isDeleted: true } : l
        )
      } else {
        // For new levels, remove completely
        updatedLevels = updatedLevels.filter(l => l.code !== code)
        updatedNewLevels = updatedNewLevels.filter(l => l.code !== code)
      }

      // Normalize levels với xử lý status đúng
      const normalizedLevels = normalizeLevels(updatedLevels)

      // Update state
      setApprovalLevels(normalizedLevels)
      setDeletedApprovalLevels(updatedDeletedLevels)
      setNewApprovalLevels(updatedNewLevels)

      // Sync with store
      proposalStore.setDefaultApprovalConfigUpdate({
        approvalLevels: normalizedLevels,
      })

      // Notify the child component to update
      if (onUpdateApprovalLevels) {
        onUpdateApprovalLevels(normalizedLevels)
      }
    },
    [
      approvalLevels,
      deletedApprovalLevels,
      newApprovalLevels,
      proposalStore,
      selectPeopleStore,
      onUpdateApprovalLevels,
    ]
  )

  const handleUpdateApprovalLevels = useCallback(
    updatedLevels => {
      const normalizedLevels = normalizeLevels(updatedLevels) // Đảm bảo level được chuẩn hóa
      setApprovalLevels(normalizedLevels)
      proposalStore.setDefaultApprovalConfigUpdate(normalizedLevels)
    },
    [proposalStore]
  )

  const columns = useMemo(
    () => [
      {
        title: 'Ngày làm việc',
        dataIndex: 'date',
        key: 'date',
        render: text => <span>{moment(text).format('DD/MM/YYYY')}</span>,
      },
      {
        title: 'Buổi làm việc',
        dataIndex: 'shift',
        key: 'shift',
        render: (text, record) => (
          <Select
            style={{ width: '120px' }}
            value={text}
            onChange={value => handleShiftChange(value, record.id)}>
            <Option value={SHIFTS.ALL_DAY.key}>{SHIFTS.ALL_DAY.value}</Option>
            <Option value={SHIFTS.MORNING.key}>{SHIFTS.MORNING.value}</Option>
            <Option value={SHIFTS.AFTERNOON.key}>
              {SHIFTS.AFTERNOON.value}
            </Option>
            <Option value={SHIFTS.EMPTY.key}>{SHIFTS.EMPTY.value}</Option>
          </Select>
        ),
      },
      {
        title: 'Loại nghỉ phép',
        dataIndex: 'mode',
        key: 'mode',
        render: (text, record) => (
          <Select
            style={{ width: '160px' }}
            value={text}
            onChange={value => handleModeChange(value, record.id)}>
            <Option value={MODES.NORMAL.key}>{MODES.NORMAL.value}</Option>
            <Option value={MODES.WOMEN.key}>{MODES.WOMEN.value}</Option>
            <Option value={MODES.CHILD_CARE.key}>
              {MODES.CHILD_CARE.value}
            </Option>
            <Option value={MODES.WORK_REASON.key}>
              {MODES.WORK_REASON.value}
            </Option>
            <Option value={MODES.BY_REGIME.key}>{MODES.BY_REGIME.value}</Option>
          </Select>
        ),
      },
      {
        title: 'Loại chế độ (giờ)',
        dataIndex: 'mode_type',
        key: 'mode_type',
        width: '160px',
        render: (text, record) => {
          switch (record.mode) {
            case MODES.NORMAL.key:
            case MODES.WORK_REASON.key:
            case MODES.BY_REGIME.key:
              return (
                <InputNumber
                  style={{ width: '90px' }}
                  defaultValue={record.mode_type}
                  min={0}
                  max={8}
                  onChange={value => handleModeTypeChange(value, record.id)}
                />
              )
            case MODES.WOMEN.key:
              return <span>0.5</span>
            case MODES.CHILD_CARE.key:
              return <span>1</span>
            default:
              return null
          }
        },
      },
      {
        title: 'Ghi chú',
        dataIndex: 'note',
        key: 'note',
        width: '250px',
        render: (text, record) => (
          <Input
            value={record.note || ''}
            style={{
              border: '1px solid #d9d9d9',
              borderRadius: '6px',
              height: '32px',
              backgroundColor: '#fff',
            }}
            onChange={e => handleNoteChange(e.target.value, record.id)}
            placeholder="Nhập ghi chú"
          />
        ),
      },
    ],
    [
      handleShiftChange,
      handleModeChange,
      handleModeTypeChange,
      handleNoteChange,
    ]
  )

  const leaveAbnormalColumns = useMemo(
    () => [
      {
        title: 'Ngày làm việc',
        dataIndex: 'date',
        key: 'date',
        render: text => <span>{moment(text).format('DD/MM/YYYY')}</span>,
      },
      {
        title: 'Buổi làm việc',
        dataIndex: 'shift',
        key: 'shift',
        render: (text, record) => (
          <Select
            style={{ width: '120px' }}
            value={text}
            onChange={value => handleShiftChange(value, record.id)}>
            <Option value={SHIFTS.MORNING.key}>{SHIFTS.MORNING.value}</Option>
            <Option value={SHIFTS.AFTERNOON.key}>
              {SHIFTS.AFTERNOON.value}
            </Option>
            <Option value={SHIFTS.EMPTY.key}></Option>
          </Select>
        ),
      },
      {
        title: 'Loại nghỉ phép',
        dataIndex: 'mode',
        key: 'mode',
        render: (text, record) => (
          <Select
            style={{ width: '160px' }}
            value={text}
            onChange={value => handleModeChange(value, record.id)}>
            <Option value={MODES.NORMAL.key}>{MODES.NORMAL.value}</Option>
            <Option value={MODES.WOMEN.key}>{MODES.WOMEN.value}</Option>
            <Option value={MODES.CHILD_CARE.key}>
              {MODES.CHILD_CARE.value}
            </Option>
            <Option value={MODES.WORK_REASON.key}>
              {MODES.WORK_REASON.value}
            </Option>
            <Option value={MODES.BY_REGIME.key}>{MODES.BY_REGIME.value}</Option>
          </Select>
        ),
      },
      {
        title: 'Thời gian (giờ)',
        dataIndex: 'mode_type',
        key: 'mode_type',
        width: '150px',
        render: (text, record) => {
          switch (record.mode) {
            case MODES.NORMAL.key:
            case MODES.WORK_REASON.key:
            case MODES.BY_REGIME.key:
              return (
                <InputNumber
                  style={{ width: '90px' }}
                  value={record.mode_type}
                  min={0}
                  max={8}
                  onChange={value => handleModeTypeChange(value, record.id)}
                />
              )
            case MODES.WOMEN.key:
              return <span>0.5</span>
            case MODES.CHILD_CARE.key:
              return <span>1</span>
            default:
              return null
          }
        },
      },
      {
        title: 'Ghi chú',
        dataIndex: 'note',
        key: 'note',
        width: '250px',
        render: (text, record) => (
          <Input
            value={record.note || ''}
            style={{
              border: '1px solid #d9d9d9',
              borderRadius: '6px',
              height: '32px',
              backgroundColor: '#fff',
            }}
            onChange={e => handleNoteChange(e.target.value, record.id)}
            placeholder="Nhập ghi chú"
          />
        ),
      },
    ],
    [
      handleShiftChange,
      handleModeChange,
      handleModeTypeChange,
      handleNoteChange,
    ]
  )

  const renderedFiles = useMemo(() => {
    return originFiles.map(file => (
      <div className={'file'} key={file.file_id}>
        <FileItem
          file_id={file.file_id}
          file_name={file.file_name}
          file_type={utils.getExtensionFile(file.file_name)}
        />
        <span
          className={'delete-icon'}
          style={{ marginRight: '5px' }}
          onClick={() =>
            setOriginFiles(prev =>
              prev.filter(el => el.file_id !== file.file_id)
            )
          }>
          <DeleteOutlined />
        </span>
      </div>
    ))
  }, [originFiles])

  if (!isInitialized) {
    return <div>Đang tải...</div>
  }

  return (
    <>
      <Form
        scrollToFirstError={true}
        form={form}
        name={'phieu-trinh-khac-form'}
        layout={'vertical'}
        onFinish={onFinish}>
        <Row gutter={15}>
          <Col xs={24} lg={24}>
            <Form.Item name={'proposal_type'} label={'Loại:'}>
              <Input disabled value={name} />
            </Form.Item>
          </Col>
          <Col xs={24} lg={24}>
            <Form.Item
              name={'title'}
              label={'Tiêu đề:'}
              rules={[
                { required: true, message: 'Vui lòng nhập tiêu đề' },
                {
                  max: 500,
                  message: 'Tiêu đề không được vượt quá 500 ký tự!',
                },
                { validator: validator.validateInputString },
              ]}>
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} lg={24}>
            <Form.Item
              label={
                <div>
                  <p>Nội dung:</p>
                </div>
              }>
              <RichEditor
                key={editorContent}
                EDITOR_REF={CONTENT_REF}
                placeholder={'Nhập nội dung'}
                editorContent={editorContent}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={10}>
            <Form.Item
              initialValue={defaultDateRange}
              name={'date_picker'}
              label={'Thời gian:'}
              rules={[{ required: true, message: 'Vui lòng chọn thời gian' }]}>
              <RangePicker
                format={DATE_FORMAT_LIST}
                style={{ width: '100%' }}
                onChange={handleDateChange}
              />
            </Form.Item>
          </Col>
          {(proposalType === 'LEAVE' ||
            proposalType === 'SICK' ||
            proposalType === 'BUSINESS_TRIP' ||
            proposalType === 'RETIMEKEEPING' ||
            proposalType === 'OVERTIME_NORMAL' ||
            proposalType === 'LEAVE_ABNORMAL') &&
            proposalTimeList?.length > 0 && (
              <Col xs={24} style={{ marginBottom: '25px' }}>
                <Table
                  pagination={false}
                  columns={
                    proposalType === 'LEAVE_ABNORMAL'
                      ? leaveAbnormalColumns
                      : columns
                  }
                  rowKey={record => record.id}
                  dataSource={proposalTimeList || []}
                />
              </Col>
            )}
          <Col xs={24} lg={24}>
            <Form.Item name={'file_ids'} label={'Tài liệu đính kèm:'}>
              <Upload
                valuePropName={'fileList'}
                fileList={fileList}
                multiple={true}
                onChange={handleChangeFile}
                beforeUpload={() => false}
                iconRender={() => <FileTextOutlined />}>
                <Button htmlType={'button'}>
                  <UploadOutlined />
                  Chọn tài liệu đính kèm
                </Button>
              </Upload>
            </Form.Item>
            <OriginFilesList>{renderedFiles}</OriginFilesList>
          </Col>
          <Col xs={24} lg={24}>
            <div>
              <p>Cấp duyệt:</p>
              {otherDetail.proposal_status !== 'APPROVAL' && (
                <Button
                  icon={<PlusOutlined />}
                  onClick={handleAddApprovalLevel}>
                  Thêm cấp duyệt
                </Button>
              )}
            </div>
            <div style={{ margin: '10px 20px 0 -10px' }}>
              <ProposalStepApproveUpdate
                approvalLevelList={approvalLevels}
                styleCre={'update'}
                onRemoveApprovalLevel={handleRemoveApprovalLevel}
                onUpdateApprovalLevels={handleUpdateApprovalLevels}
                isDetail={false}
                isUpdate
              />
            </div>
          </Col>
        </Row>
        <ApprovalList />
        <SelectPeoplePopup
          disableSelectDepartment
          handleCancelSelectUser={handleCancelSelectUserDepartment}
          handleSubmitSelectUser={() =>
            setIsVisibleSelectUserDepartmentPopup(false)
          }
          isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
        />
        <FormActionFooter>
          <Button icon={<CloseOutlined />} danger onClick={props.onCancel}>
            Huỷ bỏ
          </Button>
          <Button
            loading={isUpdating}
            style={{ marginLeft: '10px' }}
            icon={<CheckOutlined />}
            type={'primary'}
            htmlType={'submit'}>
            Đồng ý chỉnh sửa
          </Button>
        </FormActionFooter>
      </Form>
    </>
  )
}

ProposalDetailUpdate.propTypes = {
  onCancel: PropTypes.func.isRequired,
  showSubmissionMenu: PropTypes.func,
  proposalStore: PropTypes.object,
  selectPeopleStore: PropTypes.object,
  fileStore: PropTypes.object,
  proposalType: PropTypes.string,
  proposalTypeStore: PropTypes.object,
  name: PropTypes.string,
  approvalTemplateStore: PropTypes.object,
}

export default memo(
  inject(
    'proposalStore',
    'selectPeopleStore',
    'fileStore',
    'proposalTypeStore',
    'approvalTemplateStore'
  )(observer(ProposalDetailUpdate))
)
